import { render, staticRenderFns } from "./transforming_demand2.vue?vue&type=template&id=c9375658&scoped=true"
import script from "./transforming_demand2.vue?vue&type=script&lang=js"
export * from "./transforming_demand2.vue?vue&type=script&lang=js"
import style0 from "./transforming_demand2.vue?vue&type=style&index=0&id=c9375658&prod&scoped=true&lang=css"
import style1 from "./transforming_demand2.vue?vue&type=style&index=1&id=c9375658&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9375658",
  null
  
)

export default component.exports